import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"
import { useUser } from "@/modules/users/hooks/useUser"
import { ClockOutlineIcon } from "@images/svgIcons/clockOutlineIcon"
import { word } from "@modules/core/utils/i18n"
import { ProfileAvatar } from "@modules/profile/common/components/profileAvatar"
import { UserEntity } from "@modules/profile/userProfile/userEntity"
import { SharedCoachStatus } from "@modules/programs/types/programTypes"
import { Check, X } from "lucide-react"

type SharedCoachViewProps = {
  profile: UserEntity
  onClick?: () => void
  onRemove?: () => void
  status?: SharedCoachStatus
  isAuthor?: boolean
  isEditing?: boolean
} & React.ComponentProps<"div">

export function SharedCoachView({
  profile,
  onClick,
  onRemove,
  status,
  isAuthor = false,
  isEditing = false,
  className,
  ...props
}: SharedCoachViewProps) {
  const user = useUser()
  const isPending = status === SharedCoachStatus.PENDING
  const isCurrentUser = user?.id === profile.id
  if (!isCurrentUser && !isAuthor && isPending) return null

  return (
    <div
      className={cn("flex flex-row items-center gap-2 rounded-[63px]", onClick && "cursor-pointer", className)}
      key={profile.id}
      onClick={onClick}
      {...props}
    >
      <ProfileAvatar profile={profile} className="size-15" />
      <div>
        <div>
          <Text fontStyle="LL">{`${profile.firstname} ${profile.lastname}`}</Text>
        </div>
        {status ? (
          isPending && (
            <Text fontStyle="BS" className="text-textDefault-caption">
              {word("program.sharedCoach.status.pending")}
            </Text>
          )
        ) : (
          <Text fontStyle="BS" className="text-textDefault-caption">
            {word("program.label.author")}
          </Text>
        )}
      </div>
      {onRemove && isEditing && (
        <X onClick={onRemove} color="currentColor" className="ml-auto cursor-pointer text-textDefault-caption" />
      )}
      {!isEditing &&
        isAuthor &&
        (isPending ? (
          <ClockOutlineIcon color="currentColor" className="ml-auto shrink-0 text-textDefault-caption" />
        ) : (
          status === SharedCoachStatus.ACCEPTED && (
            <Check color="currentColor" className="ml-auto shrink-0 text-textDefault-caption" />
          )
        ))}
    </div>
  )
}
